import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../assets/logos/logo.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__nav-wrapper" }
const _hoisted_3 = { class: "logo-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "nav"
}
const _hoisted_5 = { class: "nav__item" }
const _hoisted_6 = {
  key: 0,
  class: "nav__item"
}
const _hoisted_7 = {
  key: 0,
  class: "flex"
}
const _hoisted_8 = { class: "flex border-r" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IconLogout = _resolveComponent("IconLogout")!
  const _component_IconArticles = _resolveComponent("IconArticles")!
  const _component_IconAuthors = _resolveComponent("IconAuthors")!
  const _component_SearchBox = _resolveComponent("SearchBox")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/articles",
          class: "logo-wrapper__logo"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              class: "h-10 md:h-16",
              src: _imports_0,
              alt: "Therapie App"
            }, null, -1)
          ]))]),
          _: 1
        })
      ]),
      (_ctx.signedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_5, [
                _createVNode(_component_router_link, { to: "/sponsors" }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" Sponsoren ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              (_ctx.signedIn)
                ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                      class: "btn-logout"
                    }, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "hidden md:block mr-1" }, "Logout", -1)),
                      _createVNode(_component_IconLogout, { class: "w-5" })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.signedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSearchBy('articles'))),
              class: _normalizeClass(["btn-toggle-search", { 'btn-toggle-search--active': _ctx.isSearchByArticlesActive }])
            }, [
              _createVNode(_component_IconArticles)
            ], 2),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSearchBy('authors'))),
              class: _normalizeClass(["btn-toggle-search", { 'btn-toggle-search--active': _ctx.isSearchByAuthorsActive }])
            }, [
              _createVNode(_component_IconAuthors)
            ], 2)
          ]),
          _createVNode(_component_SearchBox, {
            class: "flex-1",
            search: _ctx.fetchSuggestions,
            "link-to-entity": _ctx.createUrlToEntity
          }, {
            default: _withCtx(({ suggestion, clearInput }) => [
              (_ctx.isSearchByArticlesActive)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "overflow-ellipsis overflow-hidden",
                    onClick: ($event: any) => (clearInput())
                  }, _toDisplayString(suggestion.content.title), 9, _hoisted_9))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "overflow-ellipsis overflow-hidden",
                    onClick: ($event: any) => (clearInput())
                  }, _toDisplayString(suggestion.content.name), 9, _hoisted_10))
            ]),
            _: 1
          }, 8, ["search", "link-to-entity"])
        ]))
      : _createCommentVNode("", true)
  ]))
}